export default{
    info:{
        companyName: 'Huddle Brasil',
        title: '',
        workspaceId: ''
    },
    colors:{
        // first: '#02F0E4',
        // second: '#83037D',
        // thirth: '#2F353A',
        // fourth: '#3F7CAC',
        // fifth: '#FFF581',
        // sixth: '#F4F4F4',
        // seventh: '#d5d7d8'
    },
    userInfo:{
        id: '',
        email: '',
        enrollmentId: ''
    }
}